import { render } from "./SellForm.vue?vue&type=template&id=8de4b74c"
import script from "./SellForm.vue?vue&type=script&lang=js"
export * from "./SellForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__